
import React from 'react';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Form } from '@/components/ui/form';
import { sleepQuestions } from './data/SleepQuestionsData';
import SleepQuestionField from './fields/SleepQuestionField';
import FormActions from './fields/FormActions';

const sleepAssessmentSchema = z.object({
  difficultyWakingUp: z.string({ required_error: "Please select an option." }),
  notWellRested: z.string({ required_error: "Please select an option." }),
  exhaustedWhenWaking: z.string({ required_error: "Please select an option." }),
  difficultyFallingAsleep: z.string({ required_error: "Please select an option." }),
  wakeUpTooEarly: z.string({ required_error: "Please select an option." }),
  wakeUpSeveralTimes: z.string({ required_error: "Please select an option." }),
  poorSleep: z.string({ required_error: "Please select an option." }),
});

interface SleepAssessmentEditProps {
  data: z.infer<typeof sleepAssessmentSchema>;
  onSave: (data: z.infer<typeof sleepAssessmentSchema>) => void;
  onCancel: () => void;
}

const SleepAssessmentEdit: React.FC<SleepAssessmentEditProps> = ({ data, onSave, onCancel }) => {
  const form = useForm<z.infer<typeof sleepAssessmentSchema>>({
    resolver: zodResolver(sleepAssessmentSchema),
    defaultValues: data
  });

  const handleSubmit = (values: z.infer<typeof sleepAssessmentSchema>) => {
    onSave(values);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-6">
        <div className="text-sm text-muted-foreground mb-4">
          Rate how often you experience the following sleep-related issues:
        </div>
        
        {sleepQuestions.map((sleepQuestion) => (
          <SleepQuestionField 
            key={sleepQuestion.id}
            form={form} 
            question={sleepQuestion} 
          />
        ))}

        <FormActions onCancel={onCancel} />
      </form>
    </Form>
  );
};

export default SleepAssessmentEdit;
